import { render, staticRenderFns } from "./StudentInfoTables.vue?vue&type=template&id=4ef40674&"
import script from "./StudentInfoTables.vue?vue&type=script&lang=ts&"
export * from "./StudentInfoTables.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports